module.exports = __webpack_public_path__ + "static/image1-1c44ed26104178b8e0801305fadd0af4.png";